import { useFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { DateRangePicker } from '@/features/analyze/components/Filter/DateRangePicker';
import { rwColors } from '@/styles/colors';
import {
  CubeIcon,
  GlobeAltIcon,
  HashtagIcon,
  TagIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { SelectedNodesList } from '../visualizer/SelectedNodesList';

export const FilterMirrorContainer = () => {
  const [filterCondition] = useFilterConditionAtom();
  const { t, i18n } = useTranslation();

  return (
    <div className="flex h-full min-h-0 w-[360px] flex-col">
      {/* タイトル部分（固定） */}
      <div className="m-2 shrink-0">
        <div className="flex items-center justify-between">
          <div
            className="text-xl font-medium"
            style={{ color: rwColors['dark-gray'] }}
          >
            Filter
          </div>
        </div>
        <hr className="my-0.5 h-[3px] bg-rw-light-gray" />
      </div>

      {/* スクロール可能なコンテンツエリア */}
      <div
        className="min-h-0 flex-1 overflow-y-auto px-2"
        style={{ maxHeight: 'calc(100vh - 200px' }}
      >
        <div className="flex flex-col">
          <div className="relative p-2">
            <DateRangePicker
              label={t('公開日時')}
              locale={i18n.language}
              selectedStart={filterCondition.publishedStartAt}
              selectedEnd={filterCondition.publishedEndAt}
              onStartChange={() => {}}
              onEndChange={() => {}}
            />
            <div
              className="absolute inset-0 z-10 cursor-not-allowed bg-white/65"
              style={{ pointerEvents: 'auto' }}
            />
          </div>
          <SelectedNodesList
            facetKey="themes"
            modes={['and', 'or']}
            label={t('テーマ')}
            labelColor={rwColors.sub}
            IconComponent={HashtagIcon}
            labelClassName="text-rw-sub"
          />

          <div className="relative">
            <SelectedNodesList
              label={t('国グループ')}
              modes={['or']}
              labelColor={rwColors['light-gray']}
              backgroundColor={rwColors['dark-gray']}
              facetKey="countryTags"
              labelClassName="text-rw-dark-gray"
            />

            <SelectedNodesList
              label={t('国')}
              modes={['or', 'not']}
              labelColor={rwColors.green}
              facetKey="countries"
              IconComponent={GlobeAltIcon}
              labelClassName="text-rw-green"
            />

            <SelectedNodesList
              label={t('組織タイプ')}
              modes={['or']}
              labelColor={rwColors.green}
              facetKey="organizationTypes"
              IconComponent={CubeIcon}
              labelClassName="text-rw-green"
            />
            <div
              className="absolute inset-0 z-10 cursor-not-allowed bg-white/65"
              style={{ pointerEvents: 'auto' }}
            />
          </div>

          <SelectedNodesList
            label={t('タグ')}
            modes={['and', 'or', 'not']}
            labelColor={rwColors.black}
            facetKey="topicTags"
            IconComponent={TagIcon}
            labelClassName="text-rw-black"
          />
        </div>
      </div>
    </div>
  );
};
